import { format } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
import React from "react";
import useLocaleByLanguage from "../../../../../utils/hooks/useLocaleByLanguage";
import useDesktopSize from "../../../../../utils/hooks/useDesktopSize";

interface IProps {
  date: number;
}

const SingleFutureTicketDate: React.FC<IProps> = ({ date }) => {
  const isValidDate = !isNaN(date);
  const locale = useLocaleByLanguage();
  const isDesktop = useDesktopSize();

  if (isValidDate) {
    if (isDesktop) {
      return (
        <div className="single-future-ticket-date">
          <b>{format(date, "MMM", { locale: locale })}</b>
          <b>{format(date, "d", { locale: locale })}</b>
        </div>
      );
    } else {
      return (
        <div className="single-future-ticket-date">
          <b>{format(utcToZonedTime(date, "Europe/Warsaw"), " d MMMM (cccc), HH:mm", { locale: locale })}</b>
        </div>
      );
    }
  }

  return null;
};

export default SingleFutureTicketDate;
